import { render, staticRenderFns } from "./UserCardExtension.vue?vue&type=template&id=991f73a6&scoped=true"
import script from "./UserCardExtension.ts?vue&type=script&lang=ts&external"
export * from "./UserCardExtension.ts?vue&type=script&lang=ts&external"
import style0 from "./UserCardExtension.vue?vue&type=style&index=0&id=991f73a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991f73a6",
  null
  
)

export default component.exports